import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
export function FloatingMessageButton() {
  return <motion.a href="sms:360-623-4531" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 2,
    duration: 0.4,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-forest hover:bg-forest-light rounded-full flex items-center justify-center shadow-2xl hover:shadow-[0_8px_30px_rgba(26,54,33,0.4)] transition-all duration-300 group" aria-label="Send us a text message" data-id="element-46">
      <MessageCircleIcon className="w-7 h-7 text-gold group-hover:scale-110 transition-transform duration-300" data-id="element-47" />

      {/* Pulse ring animation */}
      <span className="absolute inset-0 rounded-full bg-forest/30 animate-ping pointer-events-none" data-id="element-48" />
    </motion.a>;
}